import { render, staticRenderFns } from "./VxOptions.vue?vue&type=template&id=328edcd2"
import script from "./VxOptions.vue?vue&type=script&lang=js"
export * from "./VxOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports